// extracted by mini-css-extract-plugin
export default {"icon":"SearchFulltext_icon__iu7G1","input":"SearchFulltext_input__E+UpG","clear":"SearchFulltext_clear__ed9pT"};